"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlPrefix = exports.transformUrl = void 0;
var urlPrefix = exports.urlPrefix = function urlPrefix() {
  var needPrefix = window.location.href.indexOf('needPrefix') > -1;
  var hostname = window.location.hostname;
  return hostname.indexOf('shaanxi') > -1 || hostname === '59.218.152.128' || needPrefix ? '/recept' : '';
};
var transformUrl = exports.transformUrl = function transformUrl(url) {
  var regex = /^https?:\/\//i; // 字符串是否以"http://"或"https://"开头
  if (regex.test(url)) {
    return url;
  }
  return urlPrefix() + url;
};